import { render, staticRenderFns } from "./tradingData.vue?vue&type=template&id=4cbd3042&scoped=true"
import script from "./tradingData.vue?vue&type=script&lang=js"
export * from "./tradingData.vue?vue&type=script&lang=js"
import style0 from "./tradingData.vue?vue&type=style&index=0&id=4cbd3042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbd3042",
  null
  
)

export default component.exports